import React from 'react';
import { BarChart2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function ActiveSurveyWidget() {
  const navigate = useNavigate();
  return <div className="bg-white rounded-lg shadow-sm p-5 min-h-[400px] flex flex-col" data-id="element-1847">
      <div className="flex items-center justify-between mb-4" data-id="element-1848">
        <h3 className="font-semibold text-gray-900" data-id="element-1849">Sondage actif</h3>
        <BarChart2 className="h-5 w-5 text-blue-600" data-id="element-1850" />
      </div>
      <div className="text-center py-3 px-4 bg-blue-50 rounded-lg mb-4 flex-1 flex flex-col justify-center" data-id="element-1851">
        <h4 className="font-medium text-blue-800 mb-1" data-id="element-1852">
          Pulse bien-être Q4 2023
        </h4>
        <p className="text-sm text-blue-600" data-id="element-1853">
          Partagez votre ressenti sur votre environnement de travail
        </p>
        <div className="text-xs text-blue-500 mt-1" data-id="element-1854">
          Anonyme • 5 min • Fermeture dans 3 jours
        </div>
      </div>
      <button onClick={() => navigate('/sondages')} className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors duration-150 ease-in-out mt-auto" data-id="element-1855">
        Répondre maintenant
      </button>
    </div>;
}